import * as yup from "yup";


export const resetPassword = yup.object().shape({
     code: yup.number().required(),
    password: yup.string().required(),
    confirm_password: yup.string()
        .required()
        .oneOf([yup.ref('password')], 'Passwords does not match'),
})